/* import __COLOCATED_TEMPLATE__ from './success-message.hbs'; */
import Component from '@ember/component';
import { closeModal } from 'sh-www/utils/modal-controls';

export default Component.extend({
  tagName: '',

  actions: {
    confirmAction() {
      closeModal(this);
    },
  }
});
